export const isClientSide = typeof window !== "undefined";
//# sourceMappingURL=utils.js.map